module.exports = __webpack_public_path__ + "static/assets/887ec27811227ed8b66cd05c2e8d85e4.png";